<template>
  <div class="text-edit" :class="{ 'bg-white': isTranslationEdit, 'bg-gray': !isTranslationEdit, 'cursor-text': isTranslationEdit && !disableRichText, 'text-edit-outline': isRichTextFocused }" @click="handleTextEditClick">
    <style-bar v-if="!isTranslationEdit" :css-keys="['color', 'background', 'fontSize', 'textAlign']" class="mb-2" mode="text" :styles.sync="localStyles"></style-bar>
    <rich-text-input :style="localStyles" class="px-2 py-2"
    @rich-text-input-focused="handleFocus"
    @rich-text-input-blurred="handleBlur" :global-tab-classes="childClasses" :disable-input="disableRichText" :disable-variables="disableVariables" mode="textarea" :content.sync="editorContent" :json.sync="editorContentJson" :placeholder="placeholder || (!isTranslationEdit ? $t('enter_text_here') : '')"></rich-text-input>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import RichTextInput from '@/components/utils/RichTextInput'
import StyleBar from '@/components/utils/StyleBar'

export default {
  name: 'TextEdit',
  props: ['content', 'styles', 'isTranslationEdit', 'childClasses', 'disableRichText', 'placeholder', 'disableVariables'],
  components: {
    'rich-text-input': RichTextInput,
    StyleBar
  },
  computed: {
    ...mapGetters(['findDynamicVariable', 'productStcData']),

    showSuggestions () {
      return this.query
    }

  },
  watch: {
    editorContent (newVal) {
      this.updateContent()
    },

    localStyles (newVal) {
      if (newVal && newVal.clear) {
        this.$emit('update:styles', {})
      }
    },

    styles (newVal) {
      this.localStyles = this.styles ? JSON.parse(JSON.stringify(this.styles)) : {}
    }
  },
  data () {
    return {
      localStyles: {},
      editorContent: {},
      editorContentJson: {},
      isRichTextFocused: false,
      isRichTextBlurred: true
    }
  },
  methods: {
    convertToMention (string) {
      if (typeof string !== 'string') {
        return ''
      }
      const matches = string.match(/\{(.*?)\}/)

      if (matches) {
        const submatch = matches[1]
        const before = string.substr(0, string.indexOf('{'))
        const after = string.substr(string.indexOf('}') + 1)

        if (submatch.indexOf('#') > -1) {
          const fieldName = submatch.split('#')[1]
          return this.convertToMention(`${before}<span data-mention-id="${fieldName}">#${fieldName}</span>${after}`)
        } else {
          return this.convertToMention(`${before}<span data-mention-id="${this.findDynamicVariable(submatch).key}">@${submatch}</span>${after}`)
        }
      } else {
        return string
      }
    },

    updateContent () {
      this.$emit('update:content', this.editorContent)
    },

    handleFocus () {
      this.isRichTextFocused = true
      this.isRichTextBlurred = false
    },
    handleBlur () {
      this.isRichTextFocused = false
      this.isRichTextBlurred = true
      this.$emit('rich-text-input-blurred')
    },
    handleTextEditClick () {
      if (this.isRichTextBlurred) {
        this.$emit('rich-text-input-focused')
      }
    }
  },
  created () {
    this.editorContent = JSON.parse(JSON.stringify(this.content))
    this.localStyles = this.styles ? JSON.parse(JSON.stringify(this.styles)) : {}

    // this.$emit('update:content', getHTML())
  }
}
</script>

<style lang="sass">
@import '@/variables.sass'

.text-edit
  width: 100%

.edit-box
  position: relative
  .suggestion-list
    position: absolute

.menububble
  position: absolute
  display: flex
  z-index: 20
  background: #333333
  border-radius: 5px
  padding: 0.3rem
  margin-bottom: 0.5rem
  transform: translateX(-50%)
  visibility: hidden
  opacity: 0
  transition: opacity 0.2s, visibility 0.2s

  &.is-active
    opacity: 1
    visibility: visible

.menububble__button
  display: inline-flex
  background: transparent
  border: 0
  color: white
  padding: 0.2rem 0.5rem
  margin-right: 0.2rem
  border-radius: 3px
  cursor: pointer

  &:last-child
    margin-right: 0

  &:hover
    background-color: rgba(255, 255, 255, 0.1)

  &.is-active
    background-color: rgba(255, 255, 255, 0.2)

.menububble__form
  display: flex
  align-items: center

.menububble__input
  font: inherit
  border: none
  background: transparent
  color: white

.ProseMirror
  min-height: 60px
  &:focus
    outline: none

.custom-rich-input
  .text-editor
    border-bottom: none
    margin-top: 3px
    .ProseMirror
      min-height: 27px

.text-edit-outline
  outline: 2px rgba(var(--primary)) solid

.cursor-text
  cursor: text

.bg-white
  background: white

.bg-gray
  background: #f1f1f1

.bg-light-gray
  background: #F9F9F9
</style>
